<template>
	<div>
		<div class="row">
			<div class="col-md-9">
				<div class="input-group">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-3">
				<router-link class="btn btn-primary btn-block btn-lg mb-3" to="/formeditor/questionbankitem">{{ $t('new-question') }}</router-link>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="ExamQuestion"
			:dataUrl="`${$settings.APIBaseURL}/examquestions/list`"
			dataProperty="results"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectItem"
			ref="infinitescroll"
		/>
	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			search: {
				q: ""
			}
		};
	},
	mounted() {
		this.getItems();
	},
	methods: {
		newSearch() {
			this.getItems();
		},
		getItems() {
			const body = {
				search: this.search.q ? this.search.q : ""
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		selectItem(item) {
			this.$store.commit("showBlockingSpinner");
			this.$router.push(`/formeditor/questionbankitem/${item.id}`);
		}
	},
	computed: {}
};
</script>
